<template>
  <button
    v-if="y > 200"
    @click="scrollToTop"
    class="fixed bottom-6 right-6 z-300 w-12 h-12 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center"
  >
    <UIcon name="i-ph-arrow-up" class="w-6 h-6" />
  </button>
</template>
<script setup lang="ts">
import { useWindowScroll } from '@vueuse/core'

const { y } = useWindowScroll()

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>
<style scoped>

</style>